import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Empty,
  Image,
  List,
  Row,
  Space,
  Typography,
} from "antd";

import { useVideoGuides } from "./hooks/useGuides";

const { Title, Paragraph, Text } = Typography;

const buildWatchUrl = (video) => {
  if (!video?.mediaId) return "https://www.youtube.com";

  const base = `https://www.youtube.com/watch?v=${video.mediaId}`;
  if (video.channelName) {
    return `${base}&ab_channel=${encodeURIComponent(video.channelName)}`;
  }

  return base;
};

const YoutubeUserGuides = ({ currentTab }) => {
  const [activeId, setActiveId] = useState(null);
  const [VIDEO_LIST, setVIDEO_LIST] = useState([]);

  const { videoGuideList } = useVideoGuides(currentTab);

  useEffect(() => {
    if (videoGuideList?.data?.length > 0) {
      setActiveId(videoGuideList.data[0]?.mediaId);
      const list = Array.isArray(videoGuideList.data)
        ? videoGuideList.data.map((video) => ({
            ...video,
            channelName: "SEIMS",
            channelUrl: "https://www.youtube.com/@DSTIGOVZA",
            embedUrl: `https://www.youtube.com/embed/${video.mediaId}?rel=0&modestbranding=1`,
          }))
        : [];
      setVIDEO_LIST(list);
    } else {
      setVIDEO_LIST([]);
      setActiveId(null);
    }
  }, [currentTab, videoGuideList?.data]);

  const activeVideo = React.useMemo(
    () =>
      VIDEO_LIST.find((video) => video.mediaId === activeId) || VIDEO_LIST[0],
    [activeId, VIDEO_LIST],
  );

  const embedUrl = React.useMemo(() => {
    if (!activeVideo?.mediaId) return "";
    return `https://www.youtube.com/embed/${activeVideo.mediaId}?rel=0&modestbranding=1`;
  }, [activeVideo?.mediaId]);

  const currentWatchUrl = React.useMemo(
    () => buildWatchUrl(activeVideo),
    [activeVideo],
  );

  return (
    <div>
      <Row
        justify="center"
        style={{ paddingBottom: 30 }}
        className="faq-page public-portal-page"
      >
        <Col lg={18} xs={24}>
          <Title level={3}>SEIMS Video Guides</Title>
          <Paragraph>
            Play videos locally here, or open the current video directly on
            YouTube.
          </Paragraph>

          {activeVideo ? (
            <Row gutter={[24, 24]}>
              <Col xs={24} lg={16}>
                <Card className="guide-card" bordered={false}>
                  <div>
                    <div
                      style={{
                        position: "relative",
                        paddingBottom: "56.25%",
                        height: 0,
                      }}
                    >
                      <iframe
                        title={activeVideo.title}
                        src={embedUrl}
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                        }}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      />
                    </div>

                    <Space
                      direction="vertical"
                      size="small"
                      style={{ marginTop: 16 }}
                    >
                      <Title level={4} style={{ margin: 0 }}>
                        {activeVideo.title}
                      </Title>
                      {/* {activeVideo.description && (
                <Text type="secondary">{activeVideo.description}</Text>
              )} */}

                      <Space>
                        <Button
                          shape="round"
                          type="primary"
                          href={currentWatchUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Watch on YouTube
                        </Button>
                        {activeVideo.channelUrl && (
                          <Button
                            href={activeVideo.channelUrl}
                            target="_blank"
                            shape="round"
                            rel="noreferrer"
                          >
                            Visit Channel
                          </Button>
                        )}
                      </Space>
                    </Space>
                  </div>
                </Card>
              </Col>

              {/* <Row className="subscription-title">
        <Col xs={24} md={24}>
          <div className="programme-name">{programme.value}</div>
        </Col>
      </Row>
      <br></br>
      <Row>
        <Col xs={24} md={24}>
          <div className="center-align programme-img">
            <Image
              preview={false}
              // width={programme.imageWidth}
              // height={programme.imageHeight}
              src={
                isAuthorizedRole([programme?.role])
                  ? programme.subscriptionImage
                  : programme.image
              }
            />
          </div>
        </Col>
      </Row> */}

              <Col xs={24} lg={8}>
                <Card title="Video List" bordered={false}>
                  <List
                    dataSource={VIDEO_LIST}
                    renderItem={(video) => (
                      <List.Item
                        onClick={() => setActiveId(video.mediaId)}
                        style={{ cursor: "pointer" }}
                      >
                        <List.Item.Meta
                          avatar={
                            <Image
                              width={96}
                              preview={false}
                              src={`https://img.youtube.com/vi/${video.mediaId}/hqdefault.jpg`}
                              alt={video.title}
                            />
                          }
                          title={
                            <Text strong={video.mediaId === activeId}>
                              {video.title}
                            </Text>
                          }
                          description={video.channelName}
                        />
                      </List.Item>
                    )}
                  />
                </Card>
              </Col>
            </Row>
          ) : (
            <Card className="guide-card" bordered={false}>
              <Empty description="No video guides available" />
            </Card>
          )}
        </Col>
      </Row>
      {/* <div className="divider faq-page public-portal-page"></div> */}
    </div>
  );
};

export default YoutubeUserGuides;
